import React from "react";
// import { Navigate } from "react-router-dom";
// import FailTransaction from "./FailTraxn";
// import SuccessTransaction from "./SuccessTraxn";


const Response = () => {

  return (
    <></>
  )
  // if (tranxResponse !== null && tranxResponse.success)
  //   return <Navigate to="/success" state={tranxResponse} replace />;
  
  // if (tranxResponse !== null && !tranxResponse.success)
  //   return <Navigate to="/failure" state={tranxResponse} replace />;
  

  // return (
  //   <>
  //     {/* {tranxResponse!== null && tranxResponse.success ? 
  //     <SuccessTransaction successData={tranxResponse}/>
  //     :
  //     <FailTransaction failData={tranxResponse}/>
  //     } */}
  //     {/* <button type="button">
  //       <NavLink to="/"> Go to Home </NavLink>
  //     </button> */}
  //   </>
  // );
};

export default Response;
